<template>
  <div class="nav-container">
    <div class="content">
      <div style="margin-top: 12px" :class="[isLoginPage && 'login-header']">
        <h1>
          <a
            href="/home"
            style="cursor: pointer"
            title="京东DAAS"
            alt="京东DAAS"
          >
            <img
              src="//img10.360buyimg.com/img/jfs/t1/222792/27/51667/5739/6752d4e2F70def868/b6fe1636f638f162.png"
              alt="logo"
              class="logo"
            />
          </a>
        </h1>
      </div>
      <div class="right-area" v-if="!isLoginPage">
        <div class="right-area-menu">
            <div class="right-area-menu-item" v-for="(item,idx) in menuList" :class="currentView == item.link?'menu-hover':''" :key="idx" @mouseover="handleMouseOver(item)" @click="handleActive(item)">
              <div style="position:relative">{{ item.label }}<span :class="currentView == item.link?'menu-hover-botm':''" ></span></div>
              <j-icon v-show="['营销产品','应用场景'].indexOf(item.label)>-1" font-size="12" style="padding-left:5px;" :type="currentView == item.link?'arrow-up':'arrow-down'"></j-icon>
            </div>
            <div class="product" v-show="active">
                  <div class="product-title"  v-for="product in productList"  :key="product.link" @click="handleProductClick(product)">{{ product.name }}</div>
              </div>
          </div>
        <div class="contact-area">
          <span class="boder" />
          <j-button type="primary" @click="gotoLogin" v-if="!hasLogin">
            登录/注册
          </j-button>
          <div style="display: inline" v-if="hasLogin">
            <j-dropdown>
              <j-button type="text">
                <div style="display: inline-flex">
                  <j-icon type="user7" font-size="14" color="#3247ff"></j-icon>
                  <span
                    style="color: #3247ff; margin-left: 5px"
                    >{{ userInfo.userName }}</span
                  >
                  <j-icon type="arrow-down" font-size="12"></j-icon>
                </div>
              </j-button>
              <template slot="dropdown">
                <j-dropdown :is-append-to-body="false" placement="right">
                  <j-dropdown-item>
                    进入产品线
                    <j-icon
                      type="arrow-right"
                      font-size="12"
                      color="#999"
                    ></j-icon>
                  </j-dropdown-item>
                  <template slot="dropdown">
                    <j-dropdown-item
                      ><span @click="jump(101)">CDP</span></j-dropdown-item
                    >
                    <j-dropdown-item
                      ><span @click="jump(102)">智推</span></j-dropdown-item
                    >
                    <j-dropdown-item
                      ><span @click="jump(201)">星图</span></j-dropdown-item
                    >
                  </template>
                </j-dropdown>
                <j-dropdown-item
                  ><span @click="goAccountManage"
                    >账号管理</span
                  ></j-dropdown-item
                >
                <j-dropdown-item
                  ><span @click="goSettle">入驻管理</span></j-dropdown-item
                >
                <j-dropdown-item
                  ><span @click="logout">退出</span></j-dropdown-item
                >
              </template>
            </j-dropdown>
          </div>
        </div>
      </div>
    </div>
        <div class="market" v-if="currentHover" @mouseout="handleMouseOut">
          <div  @click="closeBox"> <j-icon type="close2" className="market-close"></j-icon></div>
          <div class="market-left"> 产品矩阵</div>
          <div class="market-right"> 
            <div class="market-right-line" v-for="da in marketList">
              <div class="market-right-line-title">{{ da.title }}</div>
              <div  class="market-right-line-content">
                <div class="market-right-line-content-item" v-for="it in da.child" @click="routerby(it.src)">
                  <div class="market-right-line-content-title">{{it.name  }}</div>
                  <div class="market-right-line-content-text">{{ it.mess }}</div>
                </div>
              </div>
            </div>
          </div>  
        </div>
   
  </div>
</template>

<script>
import home from "../../views/home/index.vue";
import solution from "../../views/solution/index.vue";
import aboutUs from "../../views/aboutUs/index.vue";
import product from "../../views/product/index.vue";
import { mapState } from "vuex";
import { entryProductById } from "../../api/index.js";
import jnosLoginSdk from "@jd/jnos-login";
export default {
  name: "globalNav",
  data() {
    return {
      currentView: "/home",
      active:false,
      currentHover:false,
      menuList: [
        {
          name: "home",
          label: "首页",
          link: "/home",
        },
        {
          name: "market",
          label: "产品矩阵",
          link: "/cloud/market"
        },
        {
          name: "product",
          label: "应用场景",
          link: "/cloud/product"
        },
        {
          name: "solution",
          label: "生态合作",
          link: "/cloud/solution",
        },
        {
          name: "aboutUs",
          label: "联系我们",
          link: "/cloud/about/us",
        },
      ],
      productList: [
        {
          name: "经营增长",
          link: "/cloud/cdp",
        },
        {
          name: "用户增长",
          link: "/cloud/dsp",
        },
        {
          name: "营销提效",
          link: "/cloud/dmp",
        },
        {
          name: "新品创新",
          link: "/cloud/rta",
        },
      ],
      marketList:[
        {
          title:'经营增长',
          child:[
            {
              name:'商智',
              mess:'一站式运营数据开放平台，提供覆盖电商全流程的多维度数据洞察',
              src:'https://sz.jd.com/sz/view/index/login.html?ReturnUrl=https%3A%2F%2Fsz.jd.com%2F'
            },
            {
              name:'数坊',
              mess:'一站式数字化消费者运营平台，以5A模型为基础，全链路赋能营销增长',
              src:'https://4a.jd.com/datamill/common/goal.html'
            },
            {
              name:'京东消息类产品',
              mess:'消息型广告智投，实现精准营销，包含外呼、短信、5G消息、咚咚等形式',
              src:'https://jzt.jd.com/messageMarketing/index.html#/home'
            },
          ]
        },
        {
          title:'用户增长',
          child:[
            {
              name:'营销云-天链',
              mess:'一站式全域消费者资产管理和运营平台，提升品牌全域消费者营销运营效率',
              src:'https://cdp.jdx.com/ca/growth-discovery'
            },
            {
              name:'营销云-会员通',
              mess:'打通全域会员的身份、积分、等级，实现全渠道会员多维洞察及会员权益精准匹配',
              src:'https://cdp.jdx.com/ca/growth-discovery'
            }
          ]
        },
        {
          title:'营销提效',
          child:[
            {
              name:'营销云-全域监测',
              mess:'提供全域多渠道数据回收与洞察服务，助力品牌实现全链路媒体效果评估',
              src:'https://jmctracking.jd.com/login'
            },
            {
              name:'营销云-RTA智能营销',
              mess:'依托于京东消费洞察和算法引擎，帮助品牌在广告曝光前筛选高质量流量',
              src:'https://rta.jdx.com/rta/login'
            },
            {
              name:'营销云-内容营销',
              mess:'帮助品牌快速实现站外内容种草与站内营销联动的效能提升',
              src:'https://cdp.jdx.com/ca/growth-discovery'
            }
          ]
        },
        {
          title:'新品创新',
          child:[
            {
              name:'京洞察 | 新品孵化中心',
              mess:'领先的大数据洞察与小数据调研一体的市场调研与新品创新数字化平台',
              src:'https://survey.jd.com/'
            }
          ]
        },
      ],
      hasLogin: false,
    };
  },
  components: {
    home: home,
    solution: solution,
    aboutUs: aboutUs,
    product: product,
  },
  computed: {
    ...mapState(["userInfo"]),
    isLoginPage() {
      return this.$route.path == "/cloud/login";
    },
  },
  watch: {
    $route: {
      handler(val) {
        const temp = this.menuList.filter((menu) => menu.link == val.path)[0];
        this.currentView = temp ? temp.link:'/cloud/product';
      },
      immediate: true,
    },
    userInfo: {
      handler(val) {
        this.hasLogin = val && val.userName ? true : false
      },
      immediate: true,
    },
  },
  asyncData({ store, route }) {
    return store.dispatch("fetchLoginData");
  },
  methods: {
    closeBox(){
      this.currentHover = null
    },
    handleMouseOver(item){
      this.active = item.link == '/cloud/product' ? true : false
      this.currentHover = item.link == '/cloud/market' ?true :false
    },
    handleActive(item){
        this.handleMouseOver(item)
        if(item.link != '/cloud/product'){
            this.$router.push({ path: item.link })
        }else{
          this.$router.push({ path: '/cloud/cdp' })
        }
        this.currentView = item.link
        this.active = false
    },
    handleMouseOut(e){
     if(e.clientY>610){
      this.currentHover = false
     }
    },
    routerby(src){
      window.open(src, '_blank');
    },
    handleProductClick(val) {
      this.active = false
      this.currentView = "/cloud/product";
      this.$router.push({ path: val.link });
    },
    gotoLogin() {
      this.$router.push({ path: "/cloud/login" });
    },
    goAccountManage() {
      this.currentView = "";
      this.$router.push({ path: "/cloud/accountManage" });
    },
    goSettle() {
      this.currentView = "";
      this.$router.push({ path: "/cloud/settle" });
    },
    logout() {
      jnosLoginSdk.logout();
      this.hasLogin = false;
      this.$router.push({ path: "/cloud/login" });
    },
    jump(id) {
      entryProductById(id)
        .then((res) => {
          window.location.href = res.redirectUrl;
        })
        .catch(() => {
          this.$Notification["error"]({
            message: "还未绑定账号，请先绑定账号",
          });
        });
    },
  },
};
</script>


<style lang="scss" scoped>
.nav-container {
  position: fixed;
  top: 0;
  width: 100%;
  margin: 0 auto;
  height: 60px;
  z-index: 10;
  background-color: #fff;
  box-shadow: 0 2px 14px 0 #0000000d;

  .content {
    display: flex;
    margin: 0 100px;
    position: relative;
    height: 100%;
    justify-content: space-between;

    .logo {
      width: 300px;
      height:100%;
    }

    .login-header {
      margin-bottom: 22px;
    }

    .contact-area {
      vertical-align: middle;
      margin-top: 15px;
      display: inline;

      .boder {
        border-right: 1px solid #d8d8d8;
        height: 20px;
        margin-right: 24px;
        display: inline;
      }

      .text {
        color: #333;
        font-size: 14px;
      }
    }

    .right-area {
      display: flex;
      justify-content: flex-end;
        .right-area-menu{
            background: #fff;
            height: 60px;
            display: flex;
            text-align: justify;
            width: 640px;
            position: relative;
          }
        .right-area-menu-item{
          background: #fff;
          height: 60px;
          line-height: 60px;
          display: flex;
          padding: 0 35px;
          cursor:pointer;
          font-size: 14px;
          color: #666;
        }
        .right-area-menu-item:hover{
          color: #3247ff;
          font-weight: 600;
        }
        .menu-hover{
          color: #3247ff;
          font-weight: 600;
        }
        .menu-hover-botm{
          height: 2px;
          background: #3247ff;
          width: 20px;
          position: absolute;
          bottom: 0;
          left: calc(50% - 10px);
        }
    }

  }
}
a {
  text-decoration: none;
  color: #333;
}
.market{
  position: fixed;
  left: 0;
  right: 0;
  top: 60px;
  display: flex;
  z-index: 10000;
  box-shadow: 1px 5px 10px #9099d11f;
  transition: opacity 0.5s ease;
  .market-close{
    position: absolute;
    right: 30px;
    top: 20px;
    cursor: pointer;
  }
  .market-left{
    width: 560px;
    text-align: right;
    padding-right: 60px;
    padding-top: 40px;
    font-weight: 500;
    font-size: 20px;
    background-image: url('//img10.360buyimg.com/img/jfs/t1/258310/9/14006/17824/678dad57F131d32f9/83c4114ada642629.png'); /* 替换为你的图片路径 */
    background-size: cover; /* 图片覆盖整个元素 */
    background-position: center; /* 图片居中对齐 */
    background-repeat: no-repeat; /* 图片不重复 */
  }
  .market-right{
    background: #fff;
    width: 100%;
    padding-bottom: 30px;
  }
  .market-right-line-content {
    display: flex;
    font-size: 14px;
  }
  .market-right-line-content-item{
    width: 300px;
    cursor:pointer;
    height:100%;
  }
  .market-right-line-content-item:hover{
    .market-right-line-content-text,.market-right-line-content-title{
      color: #3247ff;
    }
  }
  .market-right-line{
    margin-top:30px;
  }
  .market-right-line-title{
    margin:0 40px;
    padding-bottom:10px;
    font-weight: 500;
    color: #3247ff;
    border-bottom:1px solid #e9e9e9;
    font-size: 14px;
  }
  .market-right-line-content-title{
    font-weight: 500;
    padding:10px 40px;
    font-size: 14px;
  }
  .market-right-line-content-text{
    padding:0 40px;
    font-size: 12px;
    color: #7f7e7e;
    display: -webkit-box; /* 将 display 设置为 -webkit-box */
    -webkit-line-clamp: 2; /* 设置最大行数为 2 */
    -webkit-box-orient: vertical; /* 设置文本排列方向为垂直 */
    overflow: hidden; /* 超出部分隐藏 */
    text-overflow: ellipsis; /* 使用省略号表示超出部分 */
    line-height: 1.5; /* 可选，设置行高 */
  }
  
}
.product{
  position: absolute;
  left: 245px;
  top: 60px;
  padding-top: 10px;
  background: #fff;
  box-shadow: 3px 5px 5px #9099d11f;
  .product-title{
    cursor:pointer;
    padding:5px 20px 10px;
    height:100%;
    font-size: 14px;
  }
  .product-title:hover{
      color: #3247ff;
      font-weight: 600;
  }
}
</style>
